import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { AiOutlineInfoCircle } from 'react-icons/ai';

function RefreshPage() {
  return (
    <div className='page404'>
      {/* <div className='page404_wrap'> */}
      <div style={{ paddingTop: '10%' }}>
        <div className='page404_img'>
          <AiOutlineInfoCircle
            style={{ width: '100px', height: '100px', color: '#EDD200' }}
          />
        </div>
        <div className='page404_tx_not'>
          An error has occurred. It's not your fault, don't worry and try again.
        </div>
        <div className='page404_tx_not'>
          If the problem persists, please contact customer service.
        </div>
        <div className='page404_btn margintop50'>
          {/* <div className="btn_backtohome tx_ct"><a href="#">BACK TO HOME</a></div> */}
          <Button
            className='btn_backtohome tx_ct'
            onClick={() => {
              window.location.replace('/#/main');
              window.location.reload();
            }}
            primary={true}
            style={{ marginRight: '5px' }}
          >
            BACK TO HOME
          </Button>
          <Button
            className='btn_backtohome tx_ct'
            onClick={() => {
              window.location.reload();
            }}
            primary={true}
          >
            REFRESH
          </Button>
        </div>
      </div>
    </div>
  );
}

export default RefreshPage;
